import React from "react";

const Taxes = () => {
  return (
    <>
      <p>Sometimes, regulations require Instructors to charge a tax to Users. We recommend that Instructors include that tax(es) in the price of the reservation, although some Instructors require taxes to be paid upon the start of a Class instead.</p>
      <p><strong>Note taxes&nbsp;in the Class&nbsp;listing</strong></p>
      <p>We ask that Instructors explain any necessary taxes in their listing description and, if applicable, communicate with Users before booking a class. If you are a User, it is usually a good idea to ask your Instructor about taxes ahead of time.</p>
      <p><strong>Local considerations</strong></p>
      <p>In some locations, Teache has made agreements with government officials to collect and remit certain local taxes on behalf of Instructors. The taxes vary and may include calculations based on a flat rate or percentage rate, number of Users, number of classes, or class type booked, depending on local law(s). When you book a class in one of these locations, the local taxes collected will be displayed automatically when you pay, and they will appear on your receipt once your reservation is confirmed.</p>
      <p>&nbsp;</p>
    </>
  );
};

export default Taxes;
